import { useAuth } from "./use-auth";
import { useUserInitialization } from "@/lib/hooks/use-user-initialization";

/**
 * Enhanced hook to check if the current user needs onboarding
 * Uses the cached initialization data instead of making a separate query
 * @returns Object with needsOnboarding state and loading state
 */
export function useEnhancedOnboardingCheck() {
  const { user, loading: authLoading } = useAuth();
  const { data: initData, isLoading: initLoading } = useUserInitialization(
    user?.id || null
  );

  // If no user, no onboarding needed
  if (!user) {
    return {
      needsOnboarding: false,
      loading: authLoading,
    };
  }

  // If we have initialization data, use it
  if (initData) {
    return {
      needsOnboarding: !initData.onboarding_completed,
      loading: false,
    };
  }

  // Still loading initialization data
  return {
    needsOnboarding: false, // Default to false while loading
    loading: authLoading || initLoading,
  };
}
